import styled from 'styled-components';
import colors from '../../../config/colors.json';
import screenSizes from '../../../config/screenSizes.json';

export const Container = styled.div`
    padding: 32px;
    background-color: ${colors.light};
    border-radius: 0 0 5px 5px;
`;

export const ContainerTitle = styled.div`
    padding: 32px 32px 0;
    background-color: ${colors.light};
    border-radius: 5px 5px 0 0;
    font-family: 'Poppins', sans-serif;
    p {
        margin-bottom: 0;
    }
`;


export const StyledTitle = styled.div`
    font-size: ${({ fontSize }) => fontSize || '44px'};
    text-transform: ${({ textTransform }) => textTransform};
    text-align: ${({ textAlign }) => textAlign};
    font-weight: ${({ fontWeight }) => fontWeight};
    font-family: 'Poppins', sans-serif;
    line-height: ${({ lineHeight }) => lineHeight};
    width: 100%;
    span {
        color: ${colors.red}
    }
`;

export const StyledSubTitle = styled.div`
    font-size: 16px;
    color: ${colors.grey};
    margin-bottom: 20px;
    width: 100%;
    font-family: 'Poppins', sans-serif;
`;

export const PreviewContainer = styled.div`
    border-radius: 5px;
    background-color: ${colors.lightGrey14};
    margin-bottom: 30px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    &:last-child {
        margin-bottom: 0;
    }
    @media screen and (max-width: ${screenSizes.tablet}px) {
        flex-direction: column;
    }
`;

export const PreviewColumn = styled.div`
    width: ${({ width }) => width};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    border-radius: 5px 0 0 5px;
    img {
        max-width: 345px;
        border-radius: 5px 0 0 5px;
    }
    &.secondColumn {
        padding: 0;
    }
    @media screen and (max-width: ${screenSizes.tablet}px) {
        flex-direction: column;
        width: 100%;
        margin-bottom: 15px;
    }
`;

export const StyledText = styled.div`
    font-size: 15px;
    line-height: 20px;
    margin-top: 5px;
    font-family: 'Poppins', sans-serif;
    span {
        font-weight: bold;
        line-height: 20px;
    }
`;
